import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { CompanyListing, CompanyAddEdit } from './pages';

export const RegularOperationEntityRoutes = ({ match }) => (
    <Fragment>
        <Route exact path = {`${match.path}`} component={CompanyListing} />
        <Route exact path = {`${match.path}/addEdit`} component={CompanyAddEdit} />
    </Fragment>
)